// extracted by mini-css-extract-plugin
module.exports = {"main-component":"hurryUp_main-component__39tPK"};